import { db } from "./firebase";

export function getRightsVar() {
  return db.collection("ARPvariables").doc("ToolsConsumerRightsVariables");
}

export function getRightsVarFIL() {
  return db.collection("ARPvariables").doc("ToolsConsumerRightsVariables-Fil");
}
